import { render, staticRenderFns } from "./ChickPlacement.vue?vue&type=template&id=1fc155fc&scoped=true&"
import script from "./ChickPlacement.vue?vue&type=script&lang=js&"
export * from "./ChickPlacement.vue?vue&type=script&lang=js&"
import style0 from "./ChickPlacement.vue?vue&type=style&index=0&id=1fc155fc&lang=scss&scoped=true&"
import style1 from "./ChickPlacement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc155fc",
  null
  
)

export default component.exports